<template>
    <modal ref="modal" body-class="px-2 px-lg-5 pb-5" dialog-class="modal-lg">
        <h4 class="text-center mb-4">New Tariff Details</h4>
        <deal-summary :deal="deal" />
        <h4 class="text-center my-4">Your Tariff Summary:</h4>
        <deal-tariff-summary :deal="deal" />
    </modal>
</template>

<script>
import Modal from "@/components/Modal";
import DealTariffSummary from "@/components/setup/DealTariffSummary";
import DealSummary from "@/components/setup/DealSummary";
import api from '@/utils/api';

export default {
    name: "TariffDetailsModal",
    components: {DealSummary, DealTariffSummary, Modal},
    data() {
        return {
            deal: {
                product: null,
                tariff: null
            }
        }
    },
    methods: {
        show(tariffId) {
            let that = this;
            api.tariff(tariffId).then(response => {
                that.deal = response.data.data
                that.$refs.modal.show();
            })
        },
        hide() {
            this.$refs.modal.hide();
        },
    }
}
</script>

<style scoped>

</style>
